// ============================================================
// OSRM (Open Source Routing Machine) ルート取得クライアント
// ============================================================
// 公開デモサーバー router.project-osrm.org をフリー / 認証不要で使う。
// 本番では CloudFront /osrm/* behavior でプロキシ。
//
// レスポンス: GeoJSON LineString の座標列 + distance(m) + duration(sec)
// プロファイルは driving のみ (デモサーバーの制約)。短距離の徒歩ルートには
// 十分近い結果が得られる。

const OSRM_PREFIX = '/osrm'

export interface Route {
  /** [lon, lat] の配列 (GeoJSON 順) */
  coordinates: [number, number][]
  distanceM: number
  durationSec: number
}

/**
 * 出発地点から目的地までのルートを 1 本取得。
 * @param origin      [lon, lat]
 * @param destination [lon, lat]
 * @param origin_ origin URL prefix (例: 本番では空文字列で /osrm/... に解決)
 */
export async function fetchRoute(
  origin: [number, number],
  destination: [number, number],
  baseOrigin: string = '',
): Promise<Route> {
  const o = `${origin[0]},${origin[1]}`
  const d = `${destination[0]},${destination[1]}`
  const url = `${baseOrigin}${OSRM_PREFIX}/route/v1/driving/${o};${d}?overview=full&geometries=geojson`
  const res = await fetch(url)
  if (!res.ok) throw new Error(`OSRM ${res.status}: ${url}`)
  const json: any = await res.json()
  if (json.code !== 'Ok' || !json.routes || json.routes.length === 0) {
    throw new Error(`OSRM no route: ${json.code ?? '?'}`)
  }
  const r = json.routes[0]
  return {
    coordinates: r.geometry.coordinates as [number, number][],
    distanceM: r.distance as number,
    durationSec: r.duration as number,
  }
}
